import { useMemo } from 'react';
import { useCardSectionRegistry } from '../../hooks/useCardSectionRegistry';
export const useCardContentPreviewSections = cardSectionSetting => {
  const {
    data: registry
  } = useCardSectionRegistry();
  return useMemo(() => {
    return cardSectionSetting.reduce((map, sectionSetting) => {
      const previewComponent = registry.getSectionPreviewComponent(sectionSetting.sectionKey);
      map.set(sectionSetting.sectionKey, previewComponent);
      return map;
    }, new Map());
  }, [cardSectionSetting, registry]);
};